<template>
  <v-toolbar class="navbar" v-resize="onWindowResize">
    <v-toolbar-items class="list" v-if="!isMobileVersion">
      <router-link
        v-for="link in routerLinks"
        :key="link.name"
        class="links"
        :class="{ 'active-link': link.activeSection }"
        v-scroll-to="link.hash"
        to
      >
        <span class="link-name">{{link.name}}</span>
      </router-link>
    </v-toolbar-items>
    <v-menu offset-y v-if="isMobileVersion">
      <v-btn flat slot="activator" color="white" aria-label="Menu">
        <v-icon large>menu</v-icon>
      </v-btn>
      <v-list class="menu-list">
        <v-list-tile
          v-for="link in routerLinks"
          :key="link.name"
          v-scroll-to="link.hash"
          class="menu-link"
          :class="{ 'active-link-menu': link.activeSection }"
        >
          <v-list-tile-title class="menu-name">{{ link.name }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
export default {
  data() {
    return {
      isMobileVersion: false,
      routerLinks: [
        { id: "main", name: "home", hash: "#main", activeSection: true },
        { id: "info", name: "about", hash: "#info", activeSection: false },
        {
          id: "experience",
          name: "experience",
          hash: "#experience",
          activeSection: false
        },
        {
          id: "contact",
          name: "contact me",
          hash: "#contact",
          activeSection: false
        }
      ]
    };
  },
  props: {
    activeTag: String
  },
  methods: {
    onWindowResize() {
      if (window.innerWidth <= 600) {
        this.isMobileVersion = true;
      } else {
        this.isMobileVersion = false;
      }
    }
  },
  watch: {
    activeTag: function selectActiveTag(newVal, oldVal) {
      this.routerLinks.map(link => {
        if (newVal === link.id) {
          link.activeSection = true;
        } else {
          link.activeSection = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$animate: all 0.2s ease-in-out;

.navbar {
  max-height: 64px;
  background-color: black;
  position: fixed;
  top: 0;
  font-size: 1.25rem;
  z-index: 1;
  .list {
    display: flex;
    justify-content: center;
    align-items: center;
    .links {
      color: white;
      padding: 8px;
      text-transform: uppercase;
      text-decoration: none;
      .link-name {
        transition: $animate;
        position: relative;
        &:before,
        &:after {
          content: "";
          position: absolute;
          bottom: -5px;
          width: 0px;
          height: 3px;
          margin: 5px 0 0;
          transition: $animate;
          transition-duration: 0.75s;
          opacity: 0;
        }
        &.link-name {
          &:after {
            left: 0;
            background-color: white;
          }
        }
      }
      &:hover {
        cursor: pointer;
        .link-name {
          &:before,
          &:after {
            width: 100%;
            opacity: 1;
          }
        }
      }
    }

    .active-link {
      color: black;
      background-color: white;
    }
  }
}
.menu-list {
  background-color: black;
  cursor: pointer;
  .menu-name {
    text-transform: uppercase;
    color: white;
    width: 100vw;
    transition: $animate;
    position: relative;
    &:before,
    &:after {
      content: "";
      position: absolute;
      bottom: 0px;
      width: 0px;
      height: 2px;
      margin: 5px 0 0;
      transition: $animate;
      transition-duration: 0.75s;
      opacity: 0;
    }
    &.menu-name {
      &:after {
        left: 0;
        background-color: white;
      }
    }
  }
  .menu-link:hover {
    cursor: pointer;
    .menu-name {
      &:before,
      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  }
}
.menu-list .active-link-menu {
  background-color: white;
  .menu-name {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue